import { createSlice } from "@reduxjs/toolkit";

const accessControlSlice = createSlice({
  name: "accessControl",
  initialState: JSON.parse(localStorage.getItem("access_list_data")),
  reducers: {
    setaccessControl: (state, action) => {
      return action.payload;
    },
  },
});

export const { setaccessControl } = accessControlSlice.actions;
export default accessControlSlice.reducer;
